import { createReducer, on } from "@ngrx/store";
import { TimerState } from "./timer.state";
import { timerActions } from "./timer.actions";

export const initialTimerState: TimerState = {
    startTime: undefined,
    actualTime: undefined
};

export const timerReducer = createReducer(
    initialTimerState,

    on( timerActions.setStartTime, (state) => ({ 
        ...state, 
        startTime: new Date()
    })),

    on( timerActions.updateTimer, (state) => ({ 
        ...state, 
        actualTime: new Date()
    }))    
)
  